function MandatoryBadge() {
  return (
      <span className='text-red-600 text-lg font-medium'> *</span>
  )
}

export default MandatoryBadge